import { Component, inject } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";

import { LOCALE } from "@hermes/core-app-core";
import { AnalyticsService } from "@hermes/hermes-web-fragments-analytics";

import { TrayOpenerDirective } from "@hermes/hermes-web-states-tray-state";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic-directives-sr-only-no-snippet";

import { FooterClickEvent } from "../../events/click.event";

@Component({
    selector: "h-footer-country-selector-button-deprecated",
    imports: [SrOnlyNoSnippetDirective, TrayOpenerDirective, TranslateModule],
    templateUrl: "./footer-country-selector-button-deprecated.component.html",
    styleUrls: ["./footer-country-selector-button-deprecated.component.scss"],
})
export class FooterCountrySelectorButtonDeprecatedComponent {
    private locale = inject(LOCALE);
    private analyticsService = inject(AnalyticsService);

    public sendShopInEvent($event: Event): void {
        $event.stopPropagation();

        // Remove first slash
        const label = this.locale.urlPrefix.slice(1);

        this.analyticsService.sendData(
            new FooterClickEvent({
                label,
                action: "Country_Selector",
            }),
        );
    }
}
